import type { DeskScript, User } from "../shared/contracts";

type Viewer = Pick<User, "role" | "teamIds">;

export function canCreateScript(viewer: Viewer): boolean {
  return (
    viewer.role === "admin" ||
    (viewer.role === "manager" && viewer.teamIds.length > 0)
  );
}

export function canEditScript(
  viewer: Viewer,
  script: Pick<DeskScript, "teamIds">,
): boolean {
  return (
    viewer.role === "admin" ||
    (viewer.role === "manager" &&
      script.teamIds.length > 0 &&
      script.teamIds.every((id) => viewer.teamIds.includes(id)))
  );
}
